import React from 'react';
import Tooltip from 'design-system/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const SlackChannelActionsRecommendedChannel = (props: $FIXME) => {
  return (
    <>
      <div className="recommended-container">
        {props.channel.toAdd ? (
          <>
            <Tooltip title="Remove Channel" placement="top" arrow>
              <div
                className={`remove-button ${props.isLoading ? 'disabled' : ''}`}
                onClick={() => props.onCancelAddRecommended?.(props.channel)}
              >
                <FontAwesomeIcon icon="trash" style={{ color: '#9CA3AF', fontSize: '20px' }} />
              </div>
            </Tooltip>
          </>
        ) : (
          <>
            <Tooltip title="Add Channel" placement="top" arrow>
              <div
                className={`add-button ${props.isLoading ? 'disabled' : ''}`}
                onClick={() => props.onAddRecommended?.(props.channel)}
              >
                <FontAwesomeIcon
                  icon="plus-circle"
                  style={{ color: '#9CA3AF', fontSize: '20px' }}
                />
              </div>
            </Tooltip>
          </>
        )}
      </div>
      <style>{`
        .recommended-container {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          gap: 4px;
        }

        .recommended-container-inner {
          padding: 5px 12px;
          border: 1px solid var(--color-transcription);
          display: flex;
          margin-left: 30px;
          border-radius: 36px;
        }

        .add-button {
          cursor: pointer;
          width: 20px;
          height: 20px;
        }

        .remove-button {
          cursor: pointer;
          width: 20px;
          height: 20px;
        }
      `}</style>
    </>
  );
};

export default SlackChannelActionsRecommendedChannel;
